import { brandNames, cssBrands } from "../constants/cards";

export class CreditCard {
    brand: string;
    number: string;
    isAdyen: boolean;
    nickname: string;
    situation: string; //valid, expired, expiring
    isDefaultCard: boolean;
    accountPaymentDataId: string;

    constructor(data?: any) {
        if (!data) return;

        this.brand = data.brand || data.cardBrand;
        this.number = data.number || data.cardNumber;
        this.isAdyen = data.isAdyen;
        this.nickname = data.nickname;
        this.situation = data.situation;
        // this.situation = ['valid', 'expired', 'expiring'][Math.floor(Math.random() * 3)];
        this.isDefaultCard = data.isDefaultCard;
        this.accountPaymentDataId = data.accountPaymentDataId;
    }

    public getFinalNumber(): string {
        return '•••• ' + this.number.replace(/[^0-9]/g, "");
    }

    public getBrandName(): string {
        return brandNames[this.brand];
    }

    public getBrandCSSMatching(): string {
        return cssBrands[this.brand];
    }
}

